import { Place } from "@mui/icons-material";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

const OfficeLocation = (props) => {
  const { profileDetails } = props;
  const { Address, City, Country } = profileDetails;
  const parts = [Address, City, Country].filter(Boolean);

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Office Location
        </Typography>
        <Stack direction="row" spacing={0.75} alignItems="flex-start">
          <Place sx={{ fontSize: "1.2rem", color: tokens.color.teal, mt: "2px" }} />
          <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
            {parts.length ? parts.join(", ") : "No address on file"}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default OfficeLocation;
